import { useCallback, useMemo } from 'react';
import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';
import useUser from './useUser';

const useCustomer = ({ customerId, extraFields, skip } = {}) => {
  const { user, loading: userLoading, hasCustomerPermission } = useUser();

  const query = gql`
    query UseCustomer($id: ID!) {
      customer(id: $id) { id name ${extraFields || ''} }
    }
  `;

  const id = customerId || user?.globalSettings.selectedCustomer;

  const { loading: customerLoading, refetch, data } = useQuery(query, {
    variables: {
      id,
    },
    fetchPolicy: extraFields ? 'cache-and-network' : 'cache-first',
    skip: skip || !id,
  });

  const customer = data?.customer;

  const loading = userLoading || customerLoading;
  const customerAccess = useMemo(() => customer && user?.customerAccess.find((ca) => ca.customer.id === customer.id), [customer, user]);

  const hasPermission = useCallback((permission) => hasCustomerPermission(customer?.id, permission), [customer, hasCustomerPermission]);

  return {
    customer,
    customerId: customer?.id,
    customerAccess,
    hasCustomerPermission: hasPermission,
    loading,
    refetch,
  };
};

export default useCustomer;
